import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseTypographyComponent } from '../base-typography.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-body-sm',
  template: '<span [ngClass]="ngClass"><ng-content></ng-content></span>',
  styleUrls: ['./body-small.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class BodySmallComponent extends BaseTypographyComponent {}
